export const FETCH_POSTS = "FETCH_POSTS";
export const CREATE_POST = "CREATE_POST";
export const UPDATE_POST = "UPDATE_POST";
export const DELETE_POST = "DELETE_POST";
export const INCREMENT_LIKE_COUNT = "INCREMENT_LIKE_COUNT";
export const AUTH = "AUTH";
export const LOGOUT = "LOGOUT";

